import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Subscription} from "rxjs/internal/Subscription";

@Component({
    selector: 'dln-error',
    templateUrl: './error.component.html',
    styleUrls: [
        'error.scss'
    ]
})
export class ErrorComponent implements OnInit, OnDestroy {
    errorMessage: string;
    error403: boolean;
    subscription: Subscription;

    constructor(private route: ActivatedRoute) {
    }

    ngOnInit() {
        this.subscription = this.route.data.subscribe((routeData) => {
            if (routeData.error403) {
                this.error403 = routeData.error403;
            }
            if (routeData.errorMessage) {
                this.errorMessage = routeData.errorMessage;
            }
        });
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe()
        }
    }
}
